









import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import LoginStore from '@/modules/login/stores/LoginStore'
import CodeForm from '@/modules/login/components/common/CodeForm.vue'

@Component({
  components: {
    CodeForm,
  },
})
export default class SmsForm extends Vue {
  description = 'На телефон отправлен код \n подтверждения'

  get currentUser() {
    return LoginStore.currentUser
  }

  get title(): string {
    return `${
      this.currentUser ? `Привет ${this.currentUser.firstName}.\n ` : ''
    }Введите код из SMS`
  }
}
